import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['closeButton']

  connect() {
    setTimeout(() => {
      this.slideIn()
    }, 10)
  }

  // Make the cancel button and press on `Esc` work just as the close button do.
  requestClose(e) {
    // Chrome dispatch a 'keydown' event with no information about pressed key on inputs when auto-complete.
    // Prevents these events to be interpreted as requests to close the lightbox
    if (e.type === 'keydown' && typeof e.code === 'undefined') {
      return
    }

    return this.closeButtonTarget.click()
  }

  slideIn() {
    this.element.classList.remove('translate-x-full')
  }

  slideOut(e) {
    e.preventDefault()

    this.element.classList.add('translate-x-full')

    this.element.ontransitionend = () => {
      this.close()
    }
  }

  close() {
    this.element.closest('turbo-frame').innerHTML = ''
  }
}
